export default `return (length(sin(p.zxy)-cos(p.zzx))-.5);
  }`